/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './device.scss';

/* eslint-disable import/no-unresolved, import/default */

import deviceFieldsetTemplate from './device-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function DeviceDirective($compile, $templateCache, $translate, $filter, $mdMedia, $window, $timeout, deviceService, toast, types) {
    var linker = function (scope, element) {
        var template = $templateCache.get(deviceFieldsetTemplate);
        element.html(template);

        scope.types = types;
        scope.deviceService = deviceService;

        scope.statsQuery = {
            order: '-ts',
            limit: 15,
            page: 1,
            search: null
        };

        scope.statsLimitOptions =
            [15, 30, 45];

        scope.$watch(function() { return $mdMedia('gt-md'); }, function(isGtMd) {
            scope.isGtMd = isGtMd;
            if (scope.isGtMd) {
                scope.statsLimitOptions = [15, 30, 45];
            } else {
                scope.statsLimitOptions = null;
            }
        });

        scope.$watch('device.id.id', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (newVal) {
                    reset();
                    updateDeviceStatsRows();
                    createDeviceSubscriptions();
                }
            }
        });

        scope.onDeviceIdCopied = function() {
            toast.showSuccess($translate.instant('device.id-copied-message'), 750, angular.element(element).closest(".toast-parent"), 'bottom left');
        };

        scope.requestDevStatus = requestDevStatus;

        scope.$watch('isEdit', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (scope.isEdit && scope.selectedTab > 2) {
                    scope.selectedTab = 0;
                }
            }
        });

        scope.triggerResize = function() {
            $timeout(() => {
                var w = angular.element($window);
                w.triggerHandler('resize');
                $window.dispatchEvent(new Event("resize")); //eslint-disable-line
            }, 100);
        };

        scope.$watch("statsQuery.search", function(newVal, prevVal) {
            if (!angular.equals(newVal, prevVal) && scope.statsQuery.search != null) {
                updateDeviceStatsRows();
            }
        });

        scope.$on("$destroy", function () {
            reset();
        });

        scope.enterDeviceStatisticsFilterMode = function () {
            scope.statsQuery.search = '';
        };

        scope.exitDeviceStatisticsFilterMode = function () {
            scope.statsQuery.search = null;
            updateDeviceStatsRows();
        };

        scope.onDeviceStatisticsReorder = function () {
            updateDeviceStatsRows();
        };

        scope.onDeviceStatisticsPaginate = function () {
            updateDeviceStatsRows();
        };

        scope.formatFrequency = function (frequency) {
            var res = '';
            if (angular.isDefined(frequency) && frequency != null) {
                var formatted = Number(frequency);
                formatted = formatted / 1000000;
                formatted = formatted.toFixed(1);
                formatted = (formatted * 1);
                res = formatted.toString();
            }
            return res;
        };

        scope.generateDevAddress = function() {
            scope.device.devAddress = (randomHex() + randomHex() + randomHex() + randomHex());
        };

        function requestDevStatus() {
            deviceService.requestDeviceStatus(scope.device.id.id).then(
                () => {
                    toast.showSuccess($translate.instant('device.status-requested-message'), 1500, angular.element(element).closest(".toast-parent"), 'bottom left');
                }
            );
        }

        function randomHex() {
            return toHex(Math.floor(Math.random()*255));
        }

        function toHex(d) {
            return  ("0"+(Number(d).toString(16))).slice(-2);
        }

        function reset() {
            scope.deviceState = {};
            scope.deviceStats = [];

            if (scope.deviceStateSubscriptionHandle) {
                scope.deviceStateSubscriptionHandle();
                scope.deviceStateSubscriptionHandle = null;
            }
            if (scope.deviceStatsSubscriptionHandle) {
                scope.deviceStatsSubscriptionHandle();
                scope.deviceStatsSubscriptionHandle = null;
            }

            scope.lastActivityTime = null;
            scope.onlineStatus = $translate.instant('device.offline');
            scope.onlineStatusColor = '#ff0000';

            scope.statsQuery.order = '-ts';
            scope.statsQuery.limit = 15;
            scope.statsQuery.page = 1;
            scope.statsQuery.search = null;
        }

        function createDeviceSubscriptions() {
            scope.deviceStateSubscriptionHandle = deviceService.subscribeForDeviceStateData(scope.device.id.id,
                onDeviceStateData);
            scope.deviceStatsSubscriptionHandle = deviceService.subscribeForDeviceStatsData(scope.device.id.id,
                onDeviceStatsData, onDeviceStatsDataReconnected);
        }

        function onDeviceStateData(deviceState) {
            scope.$apply(() => {
                scope.deviceState = deviceState;
                if (scope.deviceState.lastActivityTime) {
                    scope.lastActivityTime = $filter('date')(scope.deviceState.lastActivityTime, 'yyyy-MM-dd HH:mm:ss');
                } else {
                    scope.lastActivityTime = null;
                }
                if (scope.deviceState.online) {
                    scope.onlineStatus = $translate.instant('device.online');
                    scope.onlineStatusColor = '#1a901a';
                } else {
                    scope.onlineStatus = $translate.instant('device.offline');
                    scope.onlineStatusColor = '#ff0000';
                }
            });
        }

        function onDeviceStatsData(deviceStats) {
            scope.$apply(() => {
                if (deviceStats && deviceStats.length) {
                    scope.deviceStats = scope.deviceStats.concat(convertDeviceStats(deviceStats));
                }
                if (scope.deviceStats.length) {
                    scope.deviceStats.sort(function(stat1, stat2) {
                       return deviceStatsTsComparator(stat1, stat2, true);
                    });
                }
                updateDeviceStatsRows();
            });
        }

        function onDeviceStatsDataReconnected() {
            scope.$apply(() => {
                scope.deviceStats = [];
                updateDeviceStatsRows();
            });
        }

        function deviceStatsTsComparator(stat1, stat2, reverse) {
            var ts = stat1.ts - stat2.ts;
            if (ts < 0) {
                return reverse ? 1 : -1;
            } else if (ts > 0) {
                return reverse ? -1 : 1;
            } else {
                if (isUplink(stat1) && isDownlink(stat2)) {
                    return reverse ? 1 : -1;
                } else if (isDownlink(stat1) && isUplink(stat2)) {
                    return reverse ? -1 : 1;
                } else {
                    return 0;
                }
            }
        }

        function isJoin(stat) {
            return stat.messageType == 'Join Request' || stat.messageType == 'Join Accept';
        }

        function isDownlink(stat) {
            return stat.messageType == 'Downlink' || stat.messageType == 'Join Accept';
        }

        function isUplink(stat) {
            return stat.messageType == 'Uplink' || stat.messageType == 'Join Request';
        }

        function convertDeviceStats(deviceStats) {
            for (var i=0;i<deviceStats.length;i++) {
                var row = deviceStats[i];
                if (isJoin(row)) {
                    row.fcntDown = null;
                    row.fcntUp = null;
                }
                if (isUplink(row)) {
                    row.fcntDown = null;
                } else if (isDownlink(row)) {
                    row.fcntUp = null;
                    row.rssi = null;
                    row.loRaSNR = null;
                }
            }
            return deviceStats;
        }

        function updateDeviceStatsRows() {
            var result;
            if (scope.statsQuery.order == 'ts' || scope.statsQuery.order == '-ts') {
                result = scope.deviceStats.sort(function(stat1, stat2) {
                    return deviceStatsTsComparator(stat1, stat2, scope.statsQuery.order == '-ts');
                });
            } else {
                result = $filter('orderBy')(scope.deviceStats, scope.statsQuery.order);
            }
            if (scope.statsQuery.search != null) {
                result = $filter('filter')(result, {$: scope.statsQuery.search});
            }
            scope.statsRowsCount = result.length;
            var startIndex = scope.statsQuery.limit * (scope.statsQuery.page - 1);
            scope.deviceStatsRows = result.slice(startIndex, startIndex + scope.statsQuery.limit);
        }

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            device: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/device/device.directive.js